import styled from "styled-components";
import { device } from "../../../style/util/media-query";
import { size } from "../../../style/util/size";

export const GlascLogoHeightSmall = "10.5rem";
export const GlascLogoHeightLarge = "16rem";
export const GlascLogoPadding = "4rem";

export const StyledGlascLogo = styled.div`
  position: relative;
  padding: 0 0 ${GlascLogoPadding} 0;

  .icon {
    ${size("15rem", GlascLogoHeightSmall)};
    margin: 0 auto;
  }

  @media ${device.desktopL} {
    .icon {
      ${size("23rem", GlascLogoHeightLarge)};
    }
  }
`;
